import React, { useState } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { addReceiptVoucherSlice, addReceiptVoucherState } from './AddModalSlice'

import { receiptVouchersSlice } from '../ReceiptVouchersSlice'


// Components
import Modal from '../../../components/Modal/Modal'
import { InputField, NumberField, Textarea } from '../../../components/FormElements/FormElements'
import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'

import { ClientsMenu, OrdersMenu } from '../../../components/PredefinedMenus/PredefinedMenus'
import { showReciptVoucherSlice } from '../ShowModal/ShowModalSlice'
import { havePermission } from '../../../services/hoc/permissions'
import { useNotification } from '../../../services/usenotification'

import { useAPI } from '../../../services/hoc/useAPI'
import { AxiosError } from 'axios'
interface iProps {showModal:boolean,id:number,closeModal:Function}
export default ({showModal,id,closeModal}:iProps) => {

    // Translation
    const t = useTranslation()
    const {alert,alertError500}=useNotification()
    

    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { add_receipt_voucher: addReceiptVoucherState }) => state.add_receipt_voucher)
    
     const ENDPOINTS = useAPI()

    // Hooks
    const [showErrors, setShowErrors] = useState<boolean>(false)

    // Add receipt voucher
    const add = (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault()
        if (
            id ?!havePermission('Edit Receipt Voucher') :!havePermission("Add Receipt Voucher")
        ) {
            return
        }
        if (
            !state.fields.voucher_no ||
            !state.fields.date ||
            !state.fields.client_id ||
            !state.fields.order_id ||
            !state.fields.value ||
            !state.fields.paragraph
          
        ) {
            setShowErrors(true)
            return
        }

        dispatch(addReceiptVoucherSlice.actions.setIsLoading(true))

        const endpoint = id ? ENDPOINTS.receipt_vouchers().update : ENDPOINTS.receipt_vouchers().store

        endpoint({ id: id, ...state.fields, date: state.fields.date?.replace(/-/g, "/") })
            .then((response: any) => {
                dispatch(addReceiptVoucherSlice.actions.setIsSuccess(true))
                  dispatch(addReceiptVoucherSlice.actions.setIsLoading(false))

                setTimeout(() => {
                    toggle()
                    dispatch(receiptVouchersSlice.actions.addReceiptVouchers(
       
                        [{
                        ...response.data.data,
                        client_name: response.data.data.client?.name,
                        order_no: response.data.data.order?.order_no
                    }]
                    )
                    )

                    dispatch(showReciptVoucherSlice.actions.setIsOpen({ id: response.data.data.id, isOpen: true }))
                }, 1000);
            })
            .catch((err:AxiosError)=>{
                alertError500(err)
                  dispatch(addReceiptVoucherSlice.actions.setIsLoading(false))

                 dispatch(addReceiptVoucherSlice.actions.setIsSuccess(false))
            })

    }

    const toggle = () => {
        dispatch(addReceiptVoucherSlice.actions.setIsOpen(!state.isOpen))
        closeModal()
        dispatch(addReceiptVoucherSlice.actions.init())
    }
    const handleChange= (obj:any) =>{
      if (  id ?havePermission('Edit Receipt Voucher') :havePermission("Add Receipt Voucher")) {
            dispatch(addReceiptVoucherSlice.actions.set(obj))
        }
        else {
            let message = t("no_edit_permission")
            alert({en:message,ar:message},'info')
            
        }
    }

    return (
        <Modal open={showModal ||state.isOpen} toggle={toggle} padding={"10px 50px"} >

            {state.isLoading ? <WhiteboxLoader /> : ""}

            {state.isSuccess ? <SuccessMark /> : ""}

            <h2 className="text-center" style={{ margin: "0 0 20px" }}>
                {id? t("receipt_vouchers_details"):t("add_to_receipt_vouchers")}</h2>

            <form onSubmit={add} style={{ width: 400, maxWidth: "100%" }}>

                <InputField
                    label={t("voucher_no") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange({ voucher_no: e.target.value })}
                    value={state.fields.voucher_no}
                    error={(showErrors && !state.fields.voucher_no) ? t("required_error") : ""} />

                <InputField
                    type="date"
                    label={t("date") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange({ date: e.target.value })}
                    value={state.fields.date}
                    error={(showErrors && !state.fields.date) ? t("required_error") : ""} />

                <ClientsMenu
                    placeholder={t("select_client") + " *"}
                    onChange={(selected: { value: number; label: string; }) => handleChange({ client_id: selected.value, client_name: selected.label })}
                    value={state.fields.client_id ? { value: state.fields.client_id, label: state.fields.client_name } : null}
                    error={(showErrors && !state.fields.client_id) ? t("required_error") : ""} />

                <OrdersMenu
                    client_name={state.fields.client_name}
                    placeholder={t("order_no") + " *"}
                    onChange={(selected: { value: number; label: string; }) => handleChange({ order_id: selected.value, order_no: selected.label })}
                    value={state.fields.order_id ? { value: state.fields.order_id, label: state.fields.order_no } : null}
                    error={(showErrors && !state.fields.order_id) ? t("required_error") : ""} />

                <NumberField
                    label={t("value") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange({ value: Number(e.target.value) })}
                    value={state.fields.value}
                    error={(showErrors && !state.fields.value) ? t("required_error") : ""} />

                <Textarea
                    label={t("statement") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange({ paragraph: e.target.value })}
                    value={state.fields.paragraph}
                    error={(showErrors && !state.fields.paragraph) ? t("required_error") : ""} />


                <button className="button round bg-gold color-white margin-top-30" 
                style={{ padding: "0 80px", marginBottom: 5 }}>{t("submit")}</button>

            </form>

        </Modal>
    )

}